import { VisibilityOutlined, VisibilityOffOutlined } from "@mui/icons-material";
import React from "react";
import { Box, TextField, Button, IconButton, InputAdornment, CircularProgress } from "@mui/material";

const SignInForm = ({
  saving = false,
  formData,
  showPassword,
  handleInputChange,
  handleSignIn,
  setShowPassword,
}) => (
  <Box component="form" aria-label="Sign in" aria-busy={saving} onSubmit={handleSignIn} sx={{ mt: 3 }}><fieldset disabled={saving} style={{ border: 0, padding: 0, margin: 0, minWidth: 0 }}>
    <TextField
      variant="outlined"
      margin="normal"
      required
      fullWidth
      id="admin_contact"
      autoComplete="username"
      label="Email or phone"
      placeholder="you@example.com"
      name="admin_contact"
      value={formData.admin_contact}
      onChange={handleInputChange}
    />
    <TextField
      variant="outlined"
      margin="normal"
      required
      fullWidth
      name="admin_password"
      autoComplete="current-password"
      label="Password"
      type={showPassword ? "text" : "password"}
      value={formData.admin_password}
      onChange={handleInputChange}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end"><IconButton type="button" aria-label={showPassword ? "Hide password" : "Show password"} aria-pressed={showPassword} onClick={() => setShowPassword(!showPassword)}>
            {showPassword ? <VisibilityOffOutlined fontSize="small" /> : <VisibilityOutlined fontSize="small" />}
          </IconButton></InputAdornment>
        ),
      }}
    />
    <Button
      type="submit"
      fullWidth
      variant="contained"
      disabled={saving}
      startIcon={saving ? <CircularProgress size={16} color="inherit" /> : null}
      sx={{ mt: 2, mb: 1, minHeight: 44 }}
    >
      {saving ? "Signing in…" : "Sign in"}
    </Button>
  </fieldset></Box>
);

export default SignInForm;
